import { render, staticRenderFns } from "./HuntingWordsPage.vue?vue&type=template&id=3aab4be9"
import script from "./HuntingWordsPage.vue?vue&type=script&lang=js"
export * from "./HuntingWordsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports